import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { OrderMode } from '@/domains/pjazza/types/consts/OrderMode.consts.ts'

import { ORDER_MODE } from '@/domains/pjazza/types/consts/OrderMode.consts.ts'

/**
 * The diner's dine-in / takeaway choice, where a venue does both and no table
 * is joined yet.
 *
 * It lives in a store rather than on the menu page because two surfaces set the
 * same choice — the header toggle and the cart toggle — and they must not
 * disagree. Dine in by default: the diner is in the room. Ephemeral; there is
 * nothing to persist, and joining a table settles it regardless.
 */
export const useOrderModeStore = defineStore('pjazza-order-mode', () => {
  const mode = ref<OrderMode>(ORDER_MODE.DINE_IN)

  const choose = (next: OrderMode): void => {
    mode.value = next
  }

  return { mode, choose }
})
